import { inject, Service } from "@angular/core";

import { IntpCountryVisitModel, MainResponseModel } from "../models";
import { MainService } from ".";

@Service()
export class IntpCountryVisitsApiService {
  private _mainService = inject(MainService);

  public deleteVisit(id: number) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "DELETE",
      url: `country-visit/deleteById/${id}`,
    });
  }

  public getById(id: number) {
    return this._mainService.sendRequest<MainResponseModel<IntpCountryVisitModel>>({
      method: "GET",
      url: `country-visit/getById/${id}`,
    });
  }

  public saveVisit(isEdit: boolean, model: IntpCountryVisitModel) {
    return this._mainService.sendRequest<MainResponseModel>({
      method: "POST",
      url: isEdit ? `country-visit/update` : `country-visit/create`,
      data: model,
    });
  }
}
